export default "#### PayId\n\nInstant transaction. No fees.\n";